module.exports = __webpack_public_path__ + "public/img/money.38685a0f.png";